/**
 * Amount shown to airliners on pending PJO confirmation — their legs only, not the full itinerary.
 */

function parseAmount(value) {
  const parsed = parseFloat(value ?? 0);
  return Number.isFinite(parsed) ? parsed : 0;
}

function getLegPaidAmount(leg) {
  if (!leg) return 0;

  const candidates = [
    leg.paid_total_amount,
    leg.paid_amount,
    leg.display_total_fare,
    leg.amount,
  ];

  for (const value of candidates) {
    const parsed = parseAmount(value);
    if (parsed > 0) return parsed;
  }

  return 0;
}

function isLegPendingPjoForAirliner(leg) {
  if (!leg) return false;
  if (leg.booking_status === 'PendingPJOConfirmation') return true;
  if (leg.pending_pjo_confirmation === true) return true;
  if (leg.requires_pjo_confirmation === true) return true;
  return false;
}

function getBookingLegs(booking) {
  if (!booking) return [];
  if (booking.flights?.length > 0) return booking.flights;
  return [booking];
}

/**
 * Sum paid amounts for legs belonging to / awaiting this airliner.
 */
export function getAirlinerPendingBookingTotal(booking) {
  if (!booking) return 0;

  if (booking.airliner_paid_total_amount != null) {
    return parseAmount(booking.airliner_paid_total_amount);
  }
  if (booking.airliner_total_amount != null) {
    return parseAmount(booking.airliner_total_amount);
  }

  const legs = getBookingLegs(booking);
  const pendingLegs = legs.filter(isLegPendingPjoForAirliner);
  const legsToSum = pendingLegs.length > 0 ? pendingLegs : legs;

  const fromLegs = legsToSum.reduce((sum, leg) => sum + getLegPaidAmount(leg), 0);
  if (fromLegs > 0) return fromLegs;

  const pendingCount = booking.airliner_pending_leg_count;
  if (pendingCount === 1 && legs.length === 1) {
    return getLegPaidAmount(legs[0]);
  }

  return parseAmount(booking.paid_total_amount);
}

export function formatAirlinerBookingAmount(booking) {
  const currency = booking?.paid_currency || 'USD';
  const total = getAirlinerPendingBookingTotal(booking);
  return `${currency} ${total.toFixed(2)}`;
}
